module.exports = __webpack_public_path__ + "static/media/body_login.ccd5bde6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/img/body_login.jpg
// module id = 679
// module chunks = 51